import React from 'react';

import loadable from '@loadable/component';

import { RenderByExchange } from 'components/render/RenderByExchangeType';

const MobileSideMenuGlobal = loadable(() =>
  import(/* webpackChunkName: "MobileSideMenuGlobal" */ './MobileSideMenuGlobal')
);

const MobileSideMenuIndian = loadable(() =>
  import(/* webpackChunkName: "MobileSideMenuIndian" */ './MobileSideMenuIndian')
);

const MobileSideMenu = () => {
  return (
    <RenderByExchange
      indian={<MobileSideMenuIndian />}
      global={<MobileSideMenuGlobal />}
    />
  );
};

export default MobileSideMenu;
